module.exports = __webpack_public_path__ + "static/media/pic_08.84235000.JPG";